<div class="main-scrolling-area data-survey-background flex flex-row justify-start items-start">
    <div class="fixed-width-area flex flex-col">
        <div class="each-section m-b-10 flex flex-col">
            <div class="details">
                <particle-flow-chart-designer #flowChartDesigner [section]="section"
                                              [flowChartDataService]="flowChartDataService"
                                              [sourceType]="sourceType"
                                              [flowchart]="flowchart"
                                              [tabData]="selectedTab.tabData"
                                              [menuConfig]="menuConfig"
                                              [showFieldKey]="showFieldKey"
                ></particle-flow-chart-designer>
            </div>
        </div>
    </div>
</div>
